import { Checkbox as BaseCheckbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import React from 'react';
import { Spacer } from '../Spacer';

interface Props {
  checked: boolean;
  disabled?: boolean;
  onChange: (e?: any) => void;
}

export const Checkbox: React.FC<Props> = ({ checked, disabled, onChange }) => (
  <BaseCheckbox
    sx={{
      '&.Mui-checked': {
        color: '#436EB2',
      },
      '&.Mui-disabled': {
        color: '#A9A8AA',
      },
    }}
    checked={checked}
    disabled={disabled}
    onChange={onChange}
  />
);

interface LabelProps {
  error?: string;
  label: string | React.ReactNode;
  tooltip?: React.ReactNode;
  name?: string;
  excludeSpacer?: boolean;
}

export const LabeledCheckbox: React.FC<Props & LabelProps> = ({
  checked,
  disabled,
  onChange,
  error = false,
  label,
  tooltip,
  name,
  excludeSpacer,
}) => (
  <FormControl>
    <FormControlLabel
      sx={{
        color: error ? '#AC3737' : 'primary',
        '& .MuiFormControlLabel-label': {
          fontFamily: 'Instrument Sans',
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          fontWeight: 400,
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        },
      }}
      control={
        <BaseCheckbox
          sx={{
            '&.Mui-checked': {
              color: '#436EB2',
            },
            '&.Mui-disabled': {
              color: '#A9A8AA',
            },
          }}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          name={name}
        />
      }
      label={
        tooltip ? (
          <>
            {label} {tooltip}
          </>
        ) : (
          label
        )
      }
      name={name}
    />
    {error ? (
      <FormHelperText
        sx={{
          color: '#AC3737',
          fontFamily: 'Instrument Sans',
          fontSize: '0.875rem',
          lineHeight: '1rem',
          height: '1.5rem',
          marginLeft: '0',
          marginTop: '0.25rem',
        }}
      >
        {error}
      </FormHelperText>
    ) : (
      !excludeSpacer && <Spacer h={28} />
    )}
  </FormControl>
);
